var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"testsModule"}},[_c('shipping-request-component-002',{attrs:{"withLinkGenesys":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }